export const EXPRESS_DELIVERY_PERCENTAGE = 1 + 30 / 100;

export const EXPRESS_DELIVERY_PERCENTAGE_READABLE =
  EXPRESS_DELIVERY_PERCENTAGE - 1;
